import { ActionType, createReducer } from "typesafe-actions";
import { combineReducers } from "redux";
import * as actions from "store/features/general/general.actions";
import { displayError, resetUnhandledError } from "store/features/general/general.actions";

export type GeneralAction = ActionType<typeof actions>;

export type GeneralState = Readonly<{
    errors: GeneralErrorsState;
}>;

export type GeneralErrorsState = Readonly<{
    hasError: boolean;
    message: string;
}>;

export const generalErrorInitialState: GeneralErrorsState = {
    hasError: false,
    message: "",
};

export const authorizationReducer = createReducer<GeneralErrorsState, GeneralAction>(generalErrorInitialState)
    .handleAction(displayError, (state, { payload }) => {
        return {
            hasError: true,
            message: payload.message,
        };
    })
    .handleAction(resetUnhandledError, () => {
        return {
            hasError: false,
            message: "",
        };
    });

export const generalReducer = combineReducers<GeneralState>({
    errors: authorizationReducer,
});
